import React from 'react';
import { get } from 'lodash';
import queryString from 'query-string';

// local dependencies
import { priorAuthDetailSummary as PriorAuthDetailSummaryView } from 'ui/views/widgets/priorAuthDetailSummary';
import { PriorAuthDetailSummaryService } from 'services/priorAuthDetailSummary';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { withRouter } from 'react-router-dom';

// get store
const store = getStore();

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { PriorAuthDetailSummary } from 'ui/containers/PriorAuthDetailSummary';
 *
 * // render
 * <PriorAuthDetailSummary propName='propValue'/>
 */
class _PriorAuthDetailSummary extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.priorAuthDetailSummaryService = new PriorAuthDetailSummaryService();

        this.data = {
            memberId: this.props.memberId,
            eocNumber: get( queryString.parse( this.props.location.search ), 'eocNumber', null )
        };

        this.state = {
            isFetching: true,
            networkStatus: null,
            componentData: null
        };

        this.fetchComponentData();
    }

    fetchComponentData = async () => {
        log.debug( 'PriorAuthDetailSummary.fetchComponentData()' );

        this.priorAuthDetailSummaryService.cancel();

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        const { status, data } = await this.priorAuthDetailSummaryService.fetchComponentData( {
            url: this.props.widget.url,
            data: { context: { callId, callType, callerType, ...this.data } }
        } );

        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <PriorAuthDetailSummaryView
                { ...this.state }
            />
        );
    }
}

// set display name
_PriorAuthDetailSummary.displayName = '_PriorAuthDetailSummary';

// set default props
_PriorAuthDetailSummary.defaultProps = {};

// prop types
_PriorAuthDetailSummary.propTypes = {};


export const PriorAuthDetailSummary = withRouter( _PriorAuthDetailSummary );
